import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFilePicture = (props) => {
  const { fontSize = '1.5rem', color = 'text.disabled', filled = true, ...other } = props;

  if (!filled) {
    console.debug('IconFilePicture needs to be created also as outlined icon');
  }

  return (
    <Box component="span" display="block" height={fontSize} width={fontSize} {...other}>
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.53846 2C4.68846 2 4 2.68846 4 3.53846V20.4615C4 21.3115 4.68846 22 5.53846 22H17.8462C18.6962 22 19.3846 21.3115 19.3846 20.4615V7.76923C19.3846 7.56538 19.3039 7.36998 19.1593 7.22536L14.1593 2.22536C14.0146 2.08075 13.8192 2 13.6154 2H5.53846ZM13.2308 3.46484L17.9198 8.15385H14C13.5754 8.15385 13.2308 7.80923 13.2308 7.38462V3.46484ZM7.84615 8.15385C8.69615 8.15385 9.38462 8.84231 9.38462 9.69231C9.38462 10.5423 8.69615 11.2308 7.84615 11.2308C6.99615 11.2308 6.30769 10.5423 6.30769 9.69231C6.30769 8.84231 6.99615 8.15385 7.84615 8.15385ZM9.38462 14.3092C9.86096 14.3092 10.3373 14.4911 10.7007 14.8546L11.6923 15.8462L11.7043 15.8341L12.6043 16.7356C12.9289 17.0602 13.453 17.0572 13.7776 16.7326C14.1023 16.408 14.1023 15.8801 13.7776 15.5547L12.9002 14.6773C13.6287 14.1402 14.6566 14.1951 15.3161 14.8546L17.0769 16.6154V18.9231H6.30769V16.6154L8.06851 14.8546C8.43197 14.4911 8.90827 14.3092 9.38462 14.3092Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

IconFilePicture.propTypes = {
  color: PropTypes.string,
  filled: PropTypes.bool,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFilePicture;
